<template>
  <form-layout :label="label">
    <div class="d-flex justify-content-between" :class="errorMessage ? 'is-invalid' : ''">
      <datetime-input :class="hasFromError ? 'is-invalid' : ''" :value="fromValue" :set-handler="setFromHandler" />
      <div class="mx-2 d-flex align-items-center">～</div>
      <datetime-input :class="hasToError ? 'is-invalid' : ''" :value="toValue" :set-handler="setToHandler" />
    </div>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </form-layout>
</template>
<script>
import BaseVuexSearchItem from '@/views/molecules/searchItems/BaseVuexSearchItem'
import FormLayout from "@/views/templates/FormLayout";
import DatetimeInput from "@/views/atoms/inputs/DateInput";

export default {
  name: 'VuexDateRangeSearchItem',
  extends: BaseVuexSearchItem,
  components: {
    DatetimeInput,
    FormLayout
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    bind: {
      type: String,
      default: '',
    },
    bindFrom: {
      type: String,
      required: true,
    },
    bindTo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      vuex_from_column: '',
      vuex_to_column: '',
    }
  },
  created() {
    if (this.bindModule) {
      this.vuex_from_column = this.bindFrom;
      this.vuex_to_column = this.bindTo;
    } else {
      const splitBindFrom = this.bindFrom.split('/');
      this.vuex_from_column = splitBindFrom.pop();
      this.vuex_to_column = this.bindTo.split('/').pop();
      this.vuex_module = splitBindFrom.join('/');
    }
  },
  computed: {
    fromValue: {
      get() {
        return this._getter(this.vuex_from_column);
      },
      set(value) {
        this._commit(this.vuex_from_column, value);
      },
    },
    toValue: {
      get() {
        return this._getter(this.vuex_to_column);
      },
      set(value) {
        this._commit(this.vuex_to_column, value);
      },
    },
    hasFromError() {
      return (this.$store.state[this.vuex_module]?.errors?.[this.vuex_from_column] !== undefined);
    },
    hasToError() {
      return (this.$store.state[this.vuex_module]?.errors?.[this.vuex_to_column] !== undefined);
    },
    errorMessage() {
      if (this.hasFromError) {
        return this.$store.state[this.vuex_module]?.errors?.[this.vuex_from_column][0];
      } else if (this.hasToError) {
        return this.$store.state[this.vuex_module]?.errors?.[this.vuex_to_column][0];
      }
      return undefined;
    },
  },
  methods: {
    setFromHandler(payload) {
      this.fromValue = payload.value;
    },
    setToHandler(payload) {
      this.toValue = payload.value;
    },
  }
}
</script>